module.exports = __webpack_public_path__ + "static/media/triangle-reverse.b0810a7e.svg";